import { useEffect, useState } from "react";
import { useDebounceCallback } from "../../hooks";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
function useDebounceState(value, onChange, wait, leading) {
  const [currentValue, setCurrentValue] = useState(value);
  const onChangeDebounce = useDebounceCallback(onChange, wait, leading);
  const setValue = val => {
    setCurrentValue(val);
    onChangeDebounce(val);
  };
  useEffect(() => setCurrentValue(value), [value]);
  return [currentValue, setValue];
}
export function Debouncer(_ref) {
  let {
    wait = 400,
    leading = false,
    value,
    onChange,
    children
  } = _ref;
  const [current, setCurrent] = useDebounceState(value, onChange, wait, leading);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children({
      value: current,
      onChange: setCurrent
    })
  });
}
export default Debouncer;